/**
 * What the server says when it refuses a call of this workflow.
 *
 * (The build and the revision used to answer with a stream this file read. A
 * run now goes on in the server after its request is answered, and the pane
 * follows it by asking how far it got: see `BankOfChangesRunner`.)
 */

function asString(value: unknown): string {
  return typeof value === 'string' ? value : '';
}

/** The human-readable reason of a failed request, when the server gave one.
 * The contract puts it in `detail`; the backend's own exception handlers
 * re-wrap an HTTPException as `{ success: false, message }`, so both are read.
 * Only the contract's 400/404/409/422 count (an auth or internal-error message is not
 * written for the lawyer), and a serialized validation dump (`[{'type': ...}]`)
 * is not something to show. */
export function serverDetailFromErrorBody(status: number | undefined, payload: unknown): string | null {
  // 404 and 409 are the conversation's own: it is gone, or it is being worked on elsewhere.
  if (status !== 400 && status !== 404 && status !== 409 && status !== 422) return null;
  if (!payload || typeof payload !== 'object') return null;
  const body = payload as { detail?: unknown; message?: unknown; success?: unknown };
  const candidate =
    typeof body.detail === 'string' ? body.detail : body.success === false ? asString(body.message) : '';
  const text = candidate.trim();
  if (!text || /^[[{]/.test(text)) return null;
  // A 404 or a 409 is shown only in the server's Hebrew: a bare "Not Found" is not written for anyone.
  if ((status === 404 || status === 409) && !/[\u0590-\u05FF]/.test(text)) return null;
  return text;
}
